module.exports = __webpack_public_path__ + "img/1F637.39195b1a.svg";